export const CONGNO_KH_LIST_INITING = 'CONGNO_KH_LIST_INITING'

export const CONGNO_KH_NVKD_LIST_REQUESTING = 'CONGNO_KH_NVKD_LIST_REQUESTING'
export const CONGNO_KH_NVKD_LIST_SUCCESS    = 'CONGNO_KH_NVKD_LIST_SUCCESS'
export const CONGNO_KH_NVKD_LIST_ERROR      = 'CONGNO_KH_NVKD_LIST_ERROR'

export const CONGNO_KH_KH_LIST_REQUESTING = 'CONGNO_KH_KH_LIST_REQUESTING'
export const CONGNO_KH_KH_LIST_SUCCESS    = 'CONGNO_KH_KH_LIST_SUCCESS'
export const CONGNO_KH_KH_LIST_ERROR      = 'CONGNO_KH_KH_LIST_ERROR'

export const CONGNO_KH_LIST_REQUESTING = 'CONGNO_KH_LIST_REQUESTING'
export const CONGNO_KH_LIST_SUCCESS = 'CONGNO_KH_LIST_SUCCESS'
export const CONGNO_KH_LIST_ERROR = 'CONGNO_KH_LIST_ERROR'

export const CONGNO_NV_BY_KH_LIST_REQUESTING = 'CONGNO_KH_BY_KH_LIST_REQUESTING'
export const CONGNO_NV_BY_KH_LIST_SUCCESS = 'CONGNO_KH_BY_KH_LIST_SUCCESS'
export const CONGNO_NV_BY_KH_LIST_ERROR = 'CONGNO_KH_BY_KH_LIST_ERROR'

export const CONGNOCT_KH_LIST_REQUESTING = 'CONGNOCT_KH_LIST_REQUESTING'
export const CONGNOCT_KH_LIST_SUCCESS = 'CONGNOCT_KH_LIST_SUCCESS'
export const CONGNOCT_KH_LIST_ERROR = 'CONGNOCT_KH_LIST_ERROR'

export const CONGNO_KH_DVHC_LIST_REQUESTING = 'CONGNO_KH_DVHC_LIST_REQUESTING'
export const CONGNO_KH_DVHC_LIST_SUCCESS = 'CONGNO_KH_DVHC_LIST_SUCCESS'
export const CONGNO_KH_DVHC_LIST_ERROR = 'CONGNO_KH_DVHC_LIST_ERROR'


export const CONGNO_KH_EXPORT_XLS_REQUESTING = 'CONGNO_KH_EXPORT_XLS_REQUESTING'
export const CONGNO_KH_EXPORT_XLS_SUCCESS = 'CONGNO_KH_EXPORT_XLS_SUCCESS'
export const CONGNO_KH_EXPORT_XLS_ERROR = 'CONGNO_KH_EXPORT_XLS_ERROR'

export const CONGNO_KH_UPDATE_REQUESTING = 'CONGNO_KH_UPDATE_REQUESTING'
export const CONGNO_KH_UPDATE_SUCCESS = 'CONGNO_KH_UPDATE_SUCCESS'
export const CONGNO_KH_UPDATE_ERROR = 'CONGNO_KH_UPDATE_ERROR'

export const CONGNO_NV_BY_KH_EXPORT_XLS_REQUESTING = 'CONGNO_NV_BY_KH_EXPORT_XLS_REQUESTING'
export const CONGNO_NV_BY_KH_EXPORT_XLS_SUCCESS = 'CONGNO_NV_BY_KH_EXPORT_XLS_SUCCESS'
export const CONGNO_NV_BY_KH_EXPORT_XLS_ERROR = 'CONGNO_NV_BY_KH_EXPORT_XLS_ERROR'

export const CONGNO_NV_BY_KH_UPLOAD_REQUESTING = 'CONGNO_NV_BY_KH_UPLOAD_REQUESTING'
export const CONGNO_NV_BY_KH_UPLOAD_SUCCESS = 'CONGNO_NV_BY_KH_UPLOAD_SUCCESS'
export const CONGNO_NV_BY_KH_UPLOAD_ERROR = 'CONGNO_NV_BY_KH_UPLOAD_ERROR'

export const CONGNO_KH_REPORT_LIST_API = '/api/v1/congno/report_by_kh'
export const CONGNO_KH_NVKD_LIST_API = '/api/v1/users/get_list_by_quanly'
export const CONGNO_KH_KH_LIST_API = '/api/v1/khachhang/KhachByNvkd'
export const CONGNO_KH_EXPORT_XLS_API = '/api/v1/congno/export_congno_kh_list_by_store'
export const CONGNOCT_KH_LIST_API = '/api/v1/congno/congno_kh_ls_by_khId'
export const CONGNOCT_KH_EXPORT_XLS_API = '/api/v1/congno/export_congno_kh_ls_by_khId'
export const CONGNO_KH_UPDATE_API = '/api/v1/congno/congno_kh_thanh_toan_no'
export const CONGNO_NV_BY_KH_LIST_API = '/api/v1/congno/congno_nhanvien_by_kh'
export const CONGNO_NV_BY_KH_EXPORT_XLS_API = '/api/v1/congno/export_congno_nhanvien_by_kh'
export const CONGNO_KH_DVHC_LIST_API = '/api/v1/management/dvhc_get_list'
export const CONGNO_NV_BY_KH_UPDATE_TONDAU_API  = '/api/v1/congno/congno_kh_update_dau_ky' 

export const LOAI_CONG_NO = {
  KHACH_HANG: 1,
  NHAN_VIEN: 2
}



// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/constants.js